import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupportDocumentationRoutingModule } from './support-documentation-routing.module';
import { HomeComponent } from './pages/home/home.component';
import { CategoryComponent } from './pages/category/category.component';
import { ArticleComponent } from './pages/article/article.component';
import { SearchComponent } from './pages/search/search.component';
import { SharedModule } from '@app/shared/shared.module';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { CalloutCardComponent } from './components/callout-card/callout-card.component';
import { CategoryCardComponent } from './components/category-card/category-card.component';
import { CategoryCardGridComponent } from './components/category-card-grid/category-card-grid.component';
import { ShortcutLinkComponent } from './components/shortcut-link/shortcut-link.component';
import { ShortcutListComponent } from './components/shortcut-list/shortcut-list.component';
import { ScheduleCallComponent } from './pages/schedule-call/schedule-call.component';
import { DialogOfficeHoursComponent } from './components/dialog-office-hours/dialog-office-hours.component';

@NgModule({
  declarations: [
    HomeComponent,
    CategoryComponent,
    ArticleComponent,
    SearchComponent,
    SearchFieldComponent,
    CalloutCardComponent,
    CategoryCardComponent,
    CategoryCardGridComponent,
    ShortcutLinkComponent,
    ShortcutListComponent,
    ScheduleCallComponent,
    DialogOfficeHoursComponent,
  ],
  imports: [CommonModule, SupportDocumentationRoutingModule, SharedModule],
})
export class SupportDocumentationModule {}
